import { useCallback } from 'react';
import type React from 'react';
import ConditionalTile from '@/srp/ConditionalTiles/ConditionalTile';
import { useIsMobile } from '~/context/common/DeviceContext';
import {
  SoftPullLocations,
  useOpenSoftPullModal
} from '~/hooks/srp/useToggleSoftPullModal';
import CalcPercentage from '~/icons/srp/CalcPercentage';
import ClickableTile from '../ClickableTile';

export default function FinanceTile() {
  const isMobile = useIsMobile();
  const heading1 = `Finance with Carvana${isMobile ? ',' : ''}`;
  const heading2 = isMobile ? 'no impact to your credit' : '';
  const subHeading =
    'Real, personalized financing terms in less than 2 minutes, with no impact to your credit.';
  const button = 'GET PRE-QUALIFIED NOW';
  const openSoftPullModal = useOpenSoftPullModal(SoftPullLocations.Conditional);
  const handleClick = useCallback<React.MouseEventHandler>(
    ev => {
      ev.preventDefault();
      openSoftPullModal();
    },
    [openSoftPullModal]
  );

  return (
    <ClickableTile
      tileId="financetile"
      name="FinanceTile"
      handleTileClick={handleClick}
      analyticsId="Finance Tile"
    >
      <ConditionalTile
        data={{
          content: { heading1, heading2, subHeading },
          button
        }}
        hasButton
        hasToolTip={false}
        isMobile={isMobile}
        primaryButton
        small={isMobile}
        svgIcon={<CalcPercentage />}
        useMobileIcon={false}
      />
    </ClickableTile>
  );
}
